import { widget_product } from "@core/gql-mockups/products";
import { media_with_details } from "./media";

export const widgets_with_data_id = `{
    section
    widgets {
      widget_id
      widget_component_key
      fields
      form_id
      collection_id
      slider_id
      mega_menu_id
      form_data {
			    id
			    title
			    key
			    buttons
			    fields {
			      id
			      label
			      placeholder
			      hint
			      grid
			      default_value
			      is_required
			      is_disabled
			      data {
			        title
			        value
			      }
			      field_type_id
			      field_type {
			        type
			        data_type   
			      }
			      field_validations
			    }
			}
    }
}`;

export const widget_details = `{
        widget_component_key
        fields
        slider_data {
          key
          images {
            title
            description
            link
            media {
              alt
              url
            }
          }
        }
        collection_data {
          products ${widget_product}
          blogs {
            id
            title
            createdAt
            publishAt
            summary
            is_favorite
            favorites_count
            reading_time
            media {
              alt
              url
            }
            seo {
              url
              full_url
            }
            custom_fields
            category {
              title
              seo {
                full_url
              }
            }
            user {
              full_name
              email
              seo {
                  full_url
              }
              media {
                  url
                  alt
              }
            }
            
          }
          brands {
            id
            title
            media {
              alt
              url
            }
            seo {
              url
              full_url
            }
          }
          categories{
            id
            title
            parents { 
              seo {
                url
                full_url
              }
            }
            media{
              alt
              url
            }
            seo{
              url
              full_url
            }
          }
        }

}
`;

export const widget_slider_details = `
{
   images {
       title
       description
       link
       media {
           alt
           url
       }
   }
}
`;
export const widget_form_details = `
{
    id
    title
    key
    buttons
    fields {
      id
      label
      placeholder
      hint
      grid
      default_value
      is_required
      is_disabled
      data {
        title
        value
      }
      field_type_id
      field_type {
        type
        data_type   
      }
      field_validations
    }
}
`;

export const widget_mega_menu_details = `
{
    title
    value
}
`;

export const widget_blogs_details = `
{
   title
   createdAt
   publishAt
   summary
   user {
    full_name
    media {
      url
      alt
    }
   }
  category {
    title
  }
   media ${media_with_details}
   seo {
    url
    full_url
   }
}
`;

export const widget_brands_details = `
{
  title
  media ${media_with_details}
  seo {
    url
    full_url
  }
}
`;

export const widget_categories_details = `
{
  title
  parents { 
      seo {
        url
      }
  }
  media ${media_with_details}
  seo {
    url
    full_url
  }
  }
`;


export const widgets_prefix = `{
    section
    widgets {
      widget_id
      widget_component_key
      fields
      slider_data {
          key
          images {
            title
            description
            link
            slide_type
            media ${media_with_details}
          }
        }

      collection_data {
        categories ${widget_categories_details}
        brands ${widget_brands_details}
      }
    }
}`;

/* Blogs inside slider widgets (slider-blogs, slider-blogs-horizontal, boxy-blog-slider,
   most-visited-blog, seller-academy-blog-collection). The union of what those cards read,
   so one selection serves all of them. */
export const widget_blogs_cards = `{
  id
  title
  summary
  createdAt
  publishAt
  reading_time
  user {
    full_name
    media {
      url
      alt
    }
  }
  category {
    title
    media {
      url
      alt
    }
    seo {
      full_url
    }
  }
  media ${media_with_details}
  seo {
    url
    full_url
  }
}`;

/* Same shape as `widgets_prefix`, with `extra` appended inside `collection_data`, so a
   site can ask the page query for the cards of its slider widgets too. */
export const make_widgets_prefix = ({ extra = "" } = {}) => `{
    section
    widgets {
      widget_id
      widget_component_key
      fields
      slider_data {
          key
          images {
            title
            description
            link
            slide_type
            media ${media_with_details}
          }
        }

      collection_data {
        categories ${widget_categories_details}
        brands ${widget_brands_details}
        ${extra}
      }
    }
}`;

/* `widgets_prefix` + the products / blogs / countdown dates of product and blog sliders.
   Cards carry user-specific fields (is_favorite), so a page query built from this must
   not sit in a cache shared between users (init_page_server only caches it for guests). */
export const widgets_prefix_with_cards = make_widgets_prefix({
  extra: `
        collection {
          extra_fields {
            expireAt
            startAt
          }
        }
        products ${widget_product}
        blogs ${widget_blogs_cards}`,
});

// The form of a widget of the form-builder slot (data type 6): the public form with its current version, what the
// form renderer takes (the same fields as services/form-definitions GET_FORM_DEFINITION). Use it as
// `form_definition_data ${widget_form_definition_details}` in a widget selection set of your own.
export const widget_form_definition_details = `
{
    id
    title
    description
    lang
    key
    requires_login
    captcha_enabled
    current_version
    version {
      id
      version
      groups
    }
}
`;
